import API from '@/apiRequest';

/**
 * Checks if AI verification is available for the given inspection type
 * @param {string} inspectionType - The type of inspection
 * @returns {boolean} - Whether AI verification is available
 */
export const isAIVerificationAvailable = (inspectionType) => {
  const supportedTypes = ['entrada', 'aditivo', 'inventario', 'saida', 'conferencia'];
  return supportedTypes.includes(inspectionType);
};

/**
 * Handles AI verification for inspections
 * @param {string} inspectionId - The ID of the inspection to verify
 * @param {function} onSuccess - Callback function called with validation results on success
 * @param {function} onError - Callback function called with error on failure
 * @param {function} setLoading - Function to set loading state
 */
export const handleAIVerification = async (inspectionId, onSuccess, onError, setLoading) => {
  if (!inspectionId) {
    onError(new Error('Inspection ID is required'));
    return;
  }

  setLoading(true);

  try {
    const response = await API.get(`inspections/${inspectionId}/ai-verification`);
    onSuccess(response.data.validation_results);
  } catch (error) {
    console.error('AI Verification Error:', error);
    onError(error);
  } finally {
    setLoading(false);
  }
};
